import { Inject, Injectable } from "@angular/core";
import { ErrorParser } from "./ErrorParser";
import { ErrorParserToken } from "./tokens/ErrorParserToken";
import { ILogger } from "@core/errorHandler/logger";
import { PayloadError } from "@core/errorHandler/logger/PayloadError";
import { isObject } from "lodash-es";

@Injectable()
export class ErrorParsers {
    constructor(@Inject(ErrorParserToken) private erroresParser: ErrorParser[], private logger: ILogger) {}

    public obtenerErrorTraducido(error: string | string[] | { [key: string]: string[] }): string {
        if (Array.isArray(error)) {
            const mensajes: string[] = error.map(errorMensaje =>
                this.erroresParser.find(errorParser => errorParser.puedeLeerError(errorMensaje))
                    ?.traducir(errorMensaje) ?? errorMensaje)
                .filter(Boolean);
            if (mensajes.length === 0) {
                this.logger.error(new PayloadError(`Error/es no parseado/s: ${error.join("\n")}`, ""));
                return "";
            }
            return mensajes.join("\n");
        }
        const hayParser = this.erroresParser.find(errorParser => errorParser.puedeLeerError(error));
        if (isObject(error)) {
            if (hayParser != null) {
                return hayParser.traducir(error);
            }
            const mensajes: string[] = [];
            Object.keys(error).forEach(key => {
                mensajes.push(`${key}: ${error[key]}`);
            });
            this.logger.error(new PayloadError(`Error/es no parseado/s: ${mensajes.join("\n")}`, ""));
            return mensajes.join(";");
        }
        return hayParser?.traducir(error) ?? "";
    }
}
